export const AGENT_ID = 'agentId'; // only for ManualAudit
export const AUDIT_TYPE = '@type';
export const BOT_ID = 'botId'; // only for BotHandoffAudit and in the future for ManualAudit
export const VISITOR_ID = 'vid'; //only for Visitor audit
export const AGENT_TYPE = 'agentType';